import HCheckArray from "@/src-refactor/modules/shared/components/refactor/helpers/check-have-value";
import { prepareFeature } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-feature";
import { HPreparePrice } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-price-property";
import { HPreparePropertyTitle } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-title-property";
import { ICardProperty } from "@/src-refactor/modules/shared/components/refactor/model/card-property.model";
import { O_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import {
  PropertyItemList,
  PropertyListResponse
} from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-list.response";
import { getConditionStatusLabel } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-condition-status-label";

export const PropertyListAdapter = (response: PropertyListResponse | undefined) => {
  if (HCheckArray(response?.data)) {
    return response?.data.map(property => prepareProperty(property));
  } else {
    return [];
  }
};

export const prepareProperty = (item: PropertyItemList) => {
  const title = prepareTitle(item);
  const businessType = prepareBusinessType(item);
  const pictures = preparePicture(item);
  const { budget } = preparePrice(item);
  const feature = prepareFeatures(item);
  const location = prepareLocation(item);
  const syncStatus = prepareSyncStatus(item);
  const conditionStatus = getConditionStatusLabel(
    item.condition_status,
    businessType
  );
  return {
    id: item.id,
    title,
    conditionStatus,
    businessType,
    pictures,
    prices: budget,
    feature: feature,
    views: prepareFormatStand(item.views_counter),
    likes: prepareFormatStand(item.likes_counter),
    agents: HCheckArray(item.agents)
      ? item.agents?.map(agent => agent.name)?.join(", ")
      : "",
    agentsInfoFull: HCheckArray(item.agents)
      ? item.agents?.map(agent => ({
          name: agent.name,
          id: Number(agent.id),
          email: agent.email,
          agencyId: agent.agency_id,
          picture: agent.picture ?? null
        }))
      : [],
    status: item.status ?? "",
    commissionGaranted: item.total_comission ?? 0,
    nameProperty: item.name ?? "",
    location: location,
    syncStatus: syncStatus,
    isCollection: Boolean(item?.is_collection),
    lat: item.latitude,
    lng: item.longitude,
    permissionsProps: {
      agents: HCheckArray(item.agents)
        ? item.agents?.map(agent => ({ id: agent.id, agencyId: agent.agency_id }))
        : [],
      isProject: Boolean(item.project),
      idStatusProperty: item.status_id
    },
    dirtyState: item
  } as ICardProperty;
};

const prepareSyncStatus = (item: PropertyItemList) => {
  return item.sync_status;
};

const prepareFormatStand = (item: number) => {
  // me la pela chat-gpt
  if (typeof item !== "number") return 0;

  const absNum = Math.abs(item);
  if (absNum >= 1e9) return (item / 1e9).toFixed(0) + "b";
  if (absNum >= 1e6) return (item / 1e6).toFixed(0) + "m";
  if (absNum >= 1e3) return (item / 1e3).toFixed(0) + "k";
  return item.toString();
};

const prepareTitle = (item: PropertyItemList) => {
  return HPreparePropertyTitle({
    cityName: item.city ?? "",
    propertyType: item.realstate_type ?? "",
    sectorName: item.sector ?? "",
    isProject: false
  });
};

const prepareBusinessType = (item: PropertyItemList) => {
  return item.business_type;
};

const preparePicture = (item: PropertyItemList) => {
  if (item.main_picture?.big) {
    return [item.main_picture?.big];
  }
  return [];
};

const preparePrice = (item: PropertyItemList) => {
  const budget = HPreparePrice({
    alternativePrice: item?.alternate_price?.toString() ?? "",
    currencyAlternativePrice: item?.alternative_currency?.symbol ?? "",
    currencyPrice: item.currency.symbol ?? "",
    businessTypeId: O_BUSINESS_TYPE[item.business_type].id,
    isProject: Boolean(item.project),
    price: item.price,
    maximumPrice: item.project?.maximum_price
      ? item.project?.maximum_price.toString()
      : "",
    minimumPrice: item.project?.minimum_price
      ? item.project?.minimum_price.toString()
      : ""
  });
  return {
    budget
  };
};

const prepareFeatures = (item: PropertyItemList) => {
  return prepareFeature({
    bathrooms: item?.bathrooms ?? null,
    halfBathrooms: item?.half_bathrooms ?? null,
    bedrooms: item?.bedrooms ?? null,
    floorLevel: item?.floor_level ?? null,
    floorsTotal: item?.floors_total ?? null,
    sqmLand: item?.sqm_land ?? null,
    sqmConstruction: item?.sqm_construction ?? null,
    pumps: item?.pumps ?? null,
    parkingSpots: item?.parking_spots ?? null
  });
};

const prepareLocation = (item: PropertyItemList) => {
  return `${item?.sector}, ${item?.city}`;
};
